const LEGACY_WALLET_ID = "legacy-window-ethereum";
const DISCOVERY_FALLBACK_DELAY_MS = 300;

export interface InjectedWallet {
  id: string;
  name: string;
  icon?: string;
  rdns?: string;
  provider: EthereumProvider;
}

export function subscribeInjectedWallets(
  onChange: (wallets: InjectedWallet[]) => void,
): () => void {
  const wallets = new Map<string, InjectedWallet>();
  let fallbackTimer: number | undefined;

  const publish = () => {
    onChange(
      [...wallets.values()].sort((left, right) =>
        left.name.localeCompare(right.name, undefined, { sensitivity: "base" }),
      ),
    );
  };

  const addWallet = (wallet: InjectedWallet) => {
    wallets.set(wallet.id, wallet);
    publish();
  };

  const handleAnnouncement = (event: Eip6963AnnounceProviderEvent) => {
    addWallet({
      id: event.detail.info.uuid,
      name: event.detail.info.name,
      icon: event.detail.info.icon,
      rdns: event.detail.info.rdns,
      provider: event.detail.provider,
    });
  };

  window.addEventListener("eip6963:announceProvider", handleAnnouncement);
  window.dispatchEvent(new Event("eip6963:requestProvider"));

  fallbackTimer = window.setTimeout(() => {
    if (wallets.size === 0 && window.ethereum !== undefined) {
      addWallet({
        id: LEGACY_WALLET_ID,
        name: legacyWalletName(window.ethereum),
        provider: window.ethereum,
      });
    }
  }, DISCOVERY_FALLBACK_DELAY_MS);

  return () => {
    window.removeEventListener("eip6963:announceProvider", handleAnnouncement);
    if (fallbackTimer !== undefined) {
      window.clearTimeout(fallbackTimer);
    }
  };
}

function legacyWalletName(provider: EthereumProviderWithLegacyMetadata): string {
  if (provider.isRabby) {
    return "Rabby";
  }
  if (provider.isCoinbaseWallet) {
    return "Coinbase Wallet";
  }
  if (provider.isTrust) {
    return "Trust Wallet";
  }
  if (provider.isPhantom) {
    return "Phantom";
  }
  if (provider.isBraveWallet) {
    return "Brave Wallet";
  }
  if (provider.isMetaMask) {
    return "MetaMask";
  }
  return "Browser wallet";
}
